<template>
  <slot />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'JdCollectionItem',
  inheritAttrs: false,
})
</script>
